import React from 'react';

import { ReactComponent as Spinner } from 'assets/img/icons/spinner.svg';

export default function SSRLoader() {
  return (
    <div className="spinner-ssr">
      <Spinner />
    </div>
  );
}
